@if(data.html == 'basic') {
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <p>{{ data.description }}</p>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end !pr-6 !pb-5">
    <button mat-flat-button color="primary" [mat-dialog-close]="data" cdkFocusInitial>ACEPTAR</button>
  </mat-dialog-actions>
}

@if(data.html == 'advance') {
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <p>{{ data.description }}</p>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end !pl-6 !pr-6 !pb-5">
    <button mat-flat-button color="primary" [mat-dialog-close]="false" cdkFocusInitial>{{ data.cancelar }}</button>
    <button mat-flat-button color="warn" [mat-dialog-close]="data" cdkFocusInitial>{{ data.aceptar }}</button>
  </mat-dialog-actions>
}

@if(data.html == 'confirm_html') {
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <p>{{ data.description }}</p>
    <span [innerHtml]="data.descriptionHTML"></span>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end !pl-6 !pr-6 !pb-5">
    <button mat-flat-button color="primary" [mat-dialog-close]="false" cdkFocusInitial>{{ data.cancelar }}</button>
    <button mat-flat-button color="warn" [mat-dialog-close]="data" cdkFocusInitial>{{ data.aceptar }}</button>
  </mat-dialog-actions>
}

@if(data.html == 'motivo_cancelacion') {
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <p>{{ data.description }}</p>
    <mat-form-field  class="w-full">
      <mat-label>Motivo de cancelación</mat-label>
      <input matInput [(ngModel)]="data.motivo_cancelacion" #motivo_cancelacion minlength="1" maxlength="150" required/>
      <mat-hint align="end">{{motivo_cancelacion.value.length}} / 150</mat-hint>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end !pl-6 !pr-6 !pb-5">
    <button mat-stroked-button color="primary" type="button" [mat-dialog-close]="false">CANCELAR</button>
    <button mat-flat-button color="primary" type="submit" [mat-dialog-close]="data" [disabled]="motivo_cancelacion.value.length == 0 || motivo_cancelacion.value.trim() == '' ">ACEPTAR</button>
  </mat-dialog-actions>
}

@if(data.html == 'eliminar_comentario') {
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <p>{{ data.description }}</p>
    <p style="color: #3F51B5">{{ data.item.descripcion }}</p>
    <mat-divider></mat-divider>
    <sub><span class="text-red-500">ADVERTENCIA:</span> Esta acción no se puede deshacer.</sub>
    
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end !pl-6 !pr-6 !pb-5">
    <button mat-flat-button color="primary" [mat-dialog-close]="false" cdkFocusInitial>CANCELAR</button>
    <button mat-flat-button color="warn" [mat-dialog-close]="data" cdkFocusInitial>ELIMINAR</button>
  </mat-dialog-actions>
}

@if(data.html == 'tree_map') {
  <mat-dialog-content>
    <div id="chart_div" style="min-width: 200px;">
      Cargando, espere un momento...
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="!justify-end !pl-6 !pr-6 !pb-5">
    <button mat-flat-button color="primary" [mat-dialog-close]="false" cdkFocusInitial>CERRAR</button>
  </mat-dialog-actions>
}